<!-- 药店终端审批 -->
<template>
  <div>
    <div class="project-edit" v-loading.fullscreen.lock="fullscreenLoading">
      <div class="header">
        <div class="back" @click="back()">返回</div>
        <div class="title">药店终端信息审核</div>
      </div>
      <template v-if="guid">
        <!-- 基础信息start -->
        <div class="basic-infor">
          <div class="import-title">
            <span class="sub-title">基础信息</span>
          </div>
          <div class="customer-information">
            <div class="cols">
              <div class="col-itms">
                <div class="title">公司名称：</div>
                <div class="content-info w200">{{ form.tenantName || '-'}}</div>
              </div>
              <div class="col-itms second">
                <div class="title">药店类型：</div>
                <div class="content-info w300">{{ form.terminalProperty || '-'}}</div>
              </div>
            </div>
            <div class="cols">
              <div class="col-itms">
                <div class="title">
                  {{form.terminalProperty == '连锁门店'?'分店名称：':'药店名称：' }}
                </div>
                <div class="content-info w200">{{ form.customerName || '-'}}</div>
              </div>
              <div class="col-itms second">
                <div class="title">标注位置：</div>
                <div class="content-info w300">纬度：{{ form.markers.lat || '-'}}，经度：{{ form.markers.lng || ''}}</div>
              </div>
            </div>

            <div class="cols">
              <div class="col-itms">
                <div class="title">所属区域：</div>
                <div class="content-info w200">{{ form.venue || '-'}}</div>
                
              </div>
              <div class="col-itms second">
                <div class="title">详细地址：</div>
                <div class="content-info w300">{{ form.address ||'-'}}</div>
              </div>
            </div>
            <div v-show="form.terminalProperty=='连锁总部'" class="cols" >
              <div class="col-itms">
                <div class="title">直营门店数量：</div>
                <div class="content-info w200">{{ form.directStoresNum || '-'}}</div>
                
              </div>
              <div class="col-itms second">
                <div class="title">加盟门店数量：</div>
                <div class="content-info w300">{{ form.affiliatedShopNum ||'-'}}</div>
              </div>
            </div>
            <div v-show="form.terminalProperty=='连锁总部'" class="cols" >
              <div class="col-itms">
                <div class="title">连锁总部类型：</div>
                <div class="content-info w200">{{ form.chainHeadquartersType || '-'}}</div>
                
              </div>
              
            </div>

            
            <div class="cols">
              <div class="col-itms">
                <div class="title">药店联系人：</div>
                <div class="content-info w200">{{ form.contacts ||'-'}}</div>
              </div>

              <div class="col-itms second">
                <div class="title">手机号码：</div>
                <div class="content-info w300">{{ form.contactTel ||'-'}}</div>
              </div>
            </div>
            <div v-show="form.terminalProperty!=='连锁总部'" class="cols">
              
              <div class="col-itms ">
                <div class="title">经营时长（年）：</div>
                <div class="content-info w200">{{ form.manageDuration ||'-'}}</div>
              </div>
              <div class="col-itms second">
                <div class="title">面积（m²）：</div>
                <div class="content-info w300">{{ form.areaMeasure ||'-'}}</div>
              </div>
            </div>
            <div v-show="form.terminalProperty=='连锁总部'" class="cols" >
              <div class="col-itms">
                <div class="title">成立时间：</div>
                <div class="content-info w200">{{ form.establishDate || '-'}}</div>
                
              </div>
              <div class="col-itms second">
                <div class="title">企业性质：</div>
                <div class="content-info w300">{{ form.enterpriseNature ||'-'}}</div>
              </div>
            </div>
            <div v-show="form.terminalProperty=='连锁总部'" class="cols" >
              <div class="col-itms">
                <div class="title">行业地位：</div>
                <div class="content-info w200">{{ form.industryStatus || '-'}}</div>
                
              </div>
              <div class="col-itms second">
                <div class="title">司法官司：</div>
                <div class="content-info w300">{{ form.lawsuit ||'-'}}</div>
              </div>
            </div>

            <div class="cols">
              <div class="col-itms">
                <div class="title">业务指派人员：</div>
                <div class="content-info w200">{{ form.createUserName ||'-'}}</div>
              </div>
              <div class="col-itms second">
                <div class="title">建档时间：</div>
                <div class="content-info w300">{{ form.inputDate | getDate}}</div>
              </div>
            </div>
          </div>
          <img
            v-show="form.approveState && form.approveState !== 'N'"
            class="approve-img"
            :src="getApproveImg(form.approveState)"
            alt=""
          />
        </div>
        <!-- 基础信息end -->
        
        

        <!-- 审批信息start -->
        <template v-if="form.approveState !=='A'">
          <div class="second"></div>
          <div class="basic-infor">
            <div class="import-title">
              <span class="sub-title">审批信息</span>
            </div>
            <div class="customer-information">
              <div class="cols">
                <div class="col-itms">
                  <div class="title">审批人：</div>
                  <div class="content-info w200">{{ approveStaffName || '-' }}</div>
                </div>
                <div class="col-itms second">
                  <div class="title">审批时间：</div>
                  <div class="content-info w200">{{ form.approveTime | getTimeDate }}</div>
                </div>
              </div>

              <div class="cols">
                <div class="col-itms">
                  <div class="title">审批结果：</div>
                  <div class="content-info w200">{{ approveStateObj[form.approveState] || '-' }}</div>
                </div>
              </div>

              <div class="cols">
                <div class="col-itms flex-position">
                  <div class="title">原因：</div>
                  <div style="height: 60px" class="content-info content-box">{{ form.approveSuggest }}</div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <!-- 审批信息end -->
        <!-- 审批按钮 -->
        <div class="operte-btns">
          <div class="btn submit" v-if="form.approveState === 'A'" @click="toAudit('Y')">通过</div>
          <div class="btn reject" v-if="form.approveState === 'A'" @click="toAudit('N')">驳回</div>
          <div class="btn cancel" @click="back()">取消</div>
        </div>
        <!-- 审批按钮 -->
      </template>
      <template v-else>
        <div class="no-data">
          <img src="@/assets/images/no_data.png" alt="" />
        </div>
      </template>
    </div>
    <!-- 原因弹框 -->
    <el-dialog
      :title="checkedTitle"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @open="oepnDialog"
      width="450px"
    >
      <div slot="title" class="dialog-title">
        {{ checkedTitle }}
      </div>
      <div class="dialogCon">
        <!-- 原因说明 -->
        <div class="dialogCon-describe">
          <!-- <p>
            <span slot="label" style="color: red">*</span>
            <span>填写原因:</span>
          </p> -->
          <el-input
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 7 }"
            v-model="checkedIssuesText"
            maxlength="100"
            show-word-limit
            :placeholder="placeholder"
            clearable
          ></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button size="small" @click="dialogVisible = false">取 消</el-button> -->
        <el-button size="small" type="info" @click="toAuditSubmit">{{ btnTitle }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import recentDate from "@/uilt/recentDate";
export default {
  components: {},
  data() {
    return {
      
      approveStateObj: {
        A: '待审核',
        Y: '已通过',
        R: '已驳回',
        N: '初始',
      },
      fullscreenLoading: false,
      guid: '',
      approveStaffName:'',
      form: {
        approveState:'',
        tenantGuid: '',
        tenantName:'',
        customerName: '',
        terminalProperty:'',
        createUserId: '',
        createUserName: '',
        region: '',
        province: '',
        city: '',
        district: '',
        address: '',
        contacts: '',
        contactTel: '',
        lng: '',
        lat: '',
        inputDate: recentDate.getNowDay(),
        addressList: [],
        markers: '',
        manageDuration: '',
        areaMeasure: '',
        level: '', //客户等级
        chainHeadquartesGuid: '', //连锁总部Guid
        chainHeadquartesName: '', //连锁总部名称
        recordName: '', //备案名称
        directStoresNum:'',//直营门店数量
        affiliatedShopNum:'',//加盟门店数量
        markingPosition:'',
        venue:'',
        chainHeadquartersType:null,//连锁总部类型
        establishDate:null,//成立时间
        enterpriseNature:null,//企业性质
        industryStatus:null,//行业地位
        lawsuit:null//司法官司
      },
      checkedTitle: '', // 弹框标题
      btnTitle: '', // 弹框标题
      checkedIssuesText: '',
      placeholder: '', // 输入提示
      dialogVisible: false,
      tenantList:[]
    };
  },
  watch: {},
  computed: {},
  created() {
    this.getTenantOperationRelList()
    this.getDetail();
    
    // this.getNameByguid()
  },
  methods: {
    getDetail() {
      let self = this;
      // self.staffDetail = '';
      // self.defaultCheckedKeys = [];
      self.api
        .postJson(`/${serverConfig.msCustomerService}/customer/data/get-detail?` + `guid=` + this.$route.query.guid)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let form = res.data.data;
            let marker = {
              lat: form.lat,
              lng: form.lng,
            };
            // console.log(self.ruleForm.markers);
            let date = form.inputDate?self.$moment(form.inputDate).format('YYYY-MM-DD'):null; 
            
            this.$set(this,'form',form)
            // this.form = form;
            
            this.guid = form.guid;
            this.getNameByguid(form.approveStaffGuid)
            console.log('form',form,this.guid);
            let tenant=self.tenantList.filter(item=>{
              return item.sendTenantGuid==form.tenantGuid
            })
            console.log('tenant',tenant);
            
            this.form = {
              approveState:form.approveState||'A',
              tenantGuid: form.tenantGuid,
              tenantName: form.tenantName||tenant[0].sendTenantName,
              customerName: form.customerName,
              terminalProperty: form.terminalProperty,
              createUserId: form.createUserId,
              createUserName: form.createUserName,
              region: form.region,
              province: form.province,
              city: form.city,
              district: form.district,
              venue: form.venue,
              address: form.address,
              contacts: form.contacts,
              contactTel: form.contactTel,
              lng: form.lng,
              lat: form.lat,
              inputDate: date,
              addressList: [form.province, form.city, form.district],
              markers: marker,
              manageDuration: form.manageDuration,
              areaMeasure: form.areaMeasure,
              level: form.level, //客户等级
              chainHeadquartesGuid: form.chainHeadquartesGuid, //连锁总部
              chainHeadquartesName: form.chainHeadquartesName, //连锁总部
              recordName: form.recordName, //备案名称
              directStoresNum:form.directStoresNum,//直营门店数量
              affiliatedShopNum:form.affiliatedShopNum,//加盟门店数量
              markingPosition:form.markingPosition,//标注位置
              chainHeadquartersType:form.chainHeadquartersType,//连锁总部类型
              establishDate:form.establishDate?self.$moment(form.establishDate).format('YYYY-MM-DD'):null,//成立时间
              enterpriseNature:form.enterpriseNature,//企业性质
              industryStatus:form.industryStatus,//行业地位
              lawsuit:form.lawsuit//司法官司

            };
            // self.getChainHeadquartes(self.ruleForm.chainHeadquartesName);
            // self.getStaffList(self.ruleForm.tenantGuid);
            
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getTenantOperationRelList() {
      let self = this;
      self.api
        .get(
          `/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list?isService=true` +
            '&tenantGuid=' +
            localStorage.guid,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.tagsLoading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.tenantList = res.data.data;

            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    
    // 审核
    toAudit(type) {
      if (type === 'Y') {
        this.$set(this, 'checkedTitle', '填写通过备注');
        this.$set(this, 'btnTitle', '审批通过');
        this.$set(this, 'placeholder', '输入通过备注');
      } else if (type === 'N') {
        this.$set(this, 'checkedTitle', '填写驳回理由');
        this.$set(this, 'btnTitle', '驳回');
        this.$set(this, 'placeholder', '输入驳回理由（必填）');
      }
      this.dialogVisible = true;
    },
    // 提交原因
    toAuditSubmit() {
      if (this.btnTitle === '驳回') {
        if (!this.checkedIssuesText) {
          this.$message.error('请填写理由');
          return;
        }
        this.toAuditRequire('R')
      } else {
        this.toAuditRequire('Y')
      }
      this.dialogVisible = false;
    },
    // 判断是否为历史用户
    checkHisUser(item) {
      try {
        return new Promise((resolve, reject) =>{
           this.api.postJson(`/${serverConfig.msPersonnelService}/staff-roster/list`,{ idCode:item.idCode }).then(res=>{
             if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              resolve(res.data.data.records)
             } else {
              this.$message.error('请稍后重试');
             }
           })
        })
      } catch (error) {
        
      }
    },
    back() {
      let self = this;
      self.$router.push({ path: '/pharmacy', query: { tenantGuid: self.$route.query.tenantGuid } });
    },
    // todo审核接口
    toAuditRequire(approveState,callBack) {
      let userInfo = JSON.parse(localStorage.userInfo)
      this.fullscreenLoading = true;
      let query = JSON.parse(JSON.stringify(this.form))
      query.approveState = approveState
      query.approveTime = this.$moment().format('YYYY-MM-DD HH:mm:ss')
      query.approveSuggest = this.checkedIssuesText
      query.approveStaffGuid = userInfo.staffGuid
      this.api
        .put(`/${serverConfig.msPersonnelService}/xxx`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.fullscreenLoading = false;
            this.back()
            
            
          } else {
            this.$message.error(res.data.msg);
            this.fullscreenLoading = false;
          }
        })
        .catch(() => {
          this.fullscreenLoading = false;
        });
    },
    // 打开原因弹框的钩子
    oepnDialog() {
      this.checkedIssuesText = '';
    },
    // 详情页审批状态图片
    getApproveImg(approvalState) {
      let str = null;
      switch (approvalState) {
        case 'A':
          str = require('@/assets/images/ic_shenping.png');
          break;
        case 'Y':
          str = require('@/assets/images/ic_pass.png');
          break;
        case 'R':
          str = require('@/assets/images/ic_reject.png');
          break;
        case 'C':
          str = require('@/assets/images/ic_cancel.png');
          break;
      }
      return str;
    },
    
    getJSONContent(josnStr) {
      let str = ''
      if (josnStr) {
        let jsonObj = JSON.parse(josnStr)
        str = jsonObj.map(item=>item.name).join('、')
      }
      return str
    },
    getNameByguid(approveStaffGuid) {
      this.api
        .postJson(`/${serverConfig.msPersonnelService}/staff/data/get-map-by-guids`, [approveStaffGuid])
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (res.data.data) {
             let key = Object.keys(res.data.data)[0]
             this.approveStaffName = res.data.data[key]
            }
          } else {
            this.$message.error(res.data.msg);
          }
        })
        // .catch(() => {
        //   this.fullscreenLoading = false;
        // });
    },
    getName(name, key) {
      let list = this.getCodeListByKey(key);
      let lisArr = list.filter((item) => item.value == name);
      return lisArr.length ? lisArr[0].text : '-';
    },
  },
};
</script>

<style scoped>
/deep/.el-input-number__decrease {
  display: none;
}
/deep/.el-input-number__increase {
  display: none;
}
/deep/ .el-input-number .el-input__inner {
  text-align: left;
  padding-left: 15px;
}
.iframe-sty {
  width: 100%;
  border: none;
  height: 600px;
}

.flow {
  background: #fff;
  padding-left: 20px;
  margin-top: 4px;
}

.pdt100 {
  padding-bottom: 100px !important;
}

.header {
  background: #fff;
  margin: 4px 0;
  font-size: 16px;
  text-align: center;
  line-height: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 16px;
}

.header .back {
  background: #ffffff;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  width: 60px;
  height: 28px;
  line-height: 28px;
  font-size: 12px;
  cursor: pointer;
}

.import-title {
  text-align: left;
  background: #fff;
  padding: 10px 16px;
  font-size: 16px;
  position: relative;
}

.empty-tooltip {
  background: #fff;
  font-size: 16px;
  padding: 25px 0;
}

.import-title.second {
  margin-top: 4px;
}
.second {
  margin-top: 4px;
}

.header .title {
  text-align: center;
  flex: 1;
}

.customer-information {
  background: #fff;
  padding-bottom: 15px;
}

.customer-information .sub-title {
  text-align: left;
  font-size: 16px;
  line-height: 28px;
  padding: 10px 16px;
  display: flex;
  justify-content: space-between;
}

.sub-operate-add {
  color: #4fa1a4;
  margin-left: 14px;
  cursor: pointer;
}

.sub-operate-add2 {
  color: #4fa1a4;
  font-size: 14px;
  margin-left: 14px;
  cursor: pointer;
  position: absolute;
  right: 35px;
  top: 10px;
  text-align: center;
}

.sub-operate-del {
  font-size: 14px;
  color: #4fa1a4;
  cursor: pointer;
  text-align: center;
  margin: 0 20px;
}

.customer-information .cols {
  background: #fff;
  display: flex;
  padding: 4px 16px;
  padding-left: 20px;
}

.customer-information .col-itms {
  display: flex;
  align-items: center;
  margin-left: 20px;
}

.customer-information .col-itms .title {
  width: 120px;
  text-align: right;
  /* margin-right: 16px; */
}

.customer-information .col-itms.second {
  margin-left: 170px;
}

.customer-information .col-itms .title span {
  color: red;
}

.import-new-wrap {
  padding-bottom: 15px;
}

.import-new-wrap .import-step-tip {
  text-align: left;
  padding-left: 10px;
  color: #666;
  font-size: 12px;
}

.import-new-wrap .col-itms {
  align-items: baseline;
}

.operte-btns {
  background: #fff;
  margin-top: 2px;
  display: flex;
  justify-content: center;
  padding: 25px 0;
}

.operte-btns .btn {
  padding: 5px 18px;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  cursor: pointer;
  margin-right: 10px;
}

.operte-btns .btn.save {
  border: 1px solid rgba(79, 161, 164, 1);
  color: rgba(79, 161, 164, 1);
  cursor: pointer;
}

.operte-btns .btn.submit {
  border: 1px solid rgba(79, 161, 164, 1);
  background: rgba(79, 161, 164, 1);
  color: #fff;
  cursor: pointer;
}
.operte-btns .btn.reject {
  border: 1px solid #f56c6c;
  background-color: #ffffff;
  color: red;
  cursor: pointer;
}
.file-operate {
  display: flex;
}
.file-preview {
  margin-left: 10px;
  cursor: pointer;
  text-decoration: underline;
  cursor: pointer;
  color: #4fa1a4;
}
.bank-content {
  text-align: left;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  outline: 0;
  padding: 0 15px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
}
.bank-info {
  color: #a7a7a7;
}
/* 新增样式 */
.w200 {
  width: 200px;
}
.w300 {
  width: 200px;
}
.sub-title {
  color: #212121;
  font-size: 16px;
}
.title {
  color: #666666;
}
.title-col {
  color: #666666;
  text-align: left;
  height: 32px;
  line-height: 32px;
}
.content-info {
  text-align: left;
  color: #212121;
}
.other-info {
  width: 320px;
  padding-left: 70px;
}
.other-info-second {
  margin-left: 170px;
}
.content-box {
  line-height: 32px;
  width: 400px;
  min-height: 32px;
  background: #ffffff;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  padding-left: 10px;
}
.content-info-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.flex-position {
  align-items: start !important;
}
/deep/.el-dialog__footer {
  border-top: 1px solid #d9d9d9;
}
/deep/ .el-dialog__body {
  padding: 0;
}
/deep/.el-dialog__header {
  padding: 10px 15px;
}
.dialog-title {
  text-align: left;
  width: 240px;
  height: 27px;
  font-family: PingFang SC;
  font-size: 18px;
  color: #212121;
  letter-spacing: 0;
  line-height: 27px;
  font-weight: 400;
}
.dialogCon {
  border-top: 1px solid #dcdee0;
  text-align: left;
  padding: 10px 20px;
}
.basic-infor {
  position: relative;
}
.approve-img {
  position: absolute;
  top: 5px;
  right: 60px;
  width: 78px;
  height: 78px;
}
.no-data {
  padding-top: 100px;
  height: 100%;
}
</style>
